import {
    BrowserRouter as Router,
    Routes,
    Route
} from "react-router-dom";
import Home from "../routes/Home";
import Products from "../routes/Products";
import About from "../routes/About";
import ProductDetail from "../routes/ProductDetail";
import Order from "../routes/Order";
import SignIn from "../routes/SignIn";
import Profile from "../routes/Profile";
import Admin from "routes/Admin";
import Confirm from "routes/Confirm";
import Review from "routes/Review";
import CreateProduct from "routes/CreateProduct";
import ReviewCreate from "routes/ReviewCreate";

function AppRouter({userObj, isLoggedIn}) {
    return (
        <Router basename={process.env.PUBLIC_URL}>
            <Routes>
                <Route path="/" element={<Home userObj={userObj} isLoggedIn={isLoggedIn} />} />
                <Route path="/products/" element={<Products userObj={userObj} isLoggedIn={isLoggedIn} />} />
                <Route path="/product-detail/:productid" element={<ProductDetail userObj={userObj} isLoggedIn={isLoggedIn} />} />
                <Route path="/product-order/:productid" element={<Order userObj={userObj} isLoggedIn={isLoggedIn} />} />
                <Route path="/about/" element={<About userObj={userObj} isLoggedIn={isLoggedIn} />} />
                <Route path="/review/" element={<Review userObj={userObj} isLoggedIn={isLoggedIn} />} />
                <Route path="/reviewcreate/" element={<ReviewCreate userObj={userObj} isLoggedIn={isLoggedIn} />} />
                {function(){
                    if(isLoggedIn){
                        if(userObj.email === "carryvilly@gmail.com"){
                            return (
                                <>
                                    <Route path="/account/" element={<Admin userObj={userObj} isLoggedIn={isLoggedIn} />} />
                                    <Route path="/account/confirm/:orderid" element={<Confirm userObj={userObj} isLoggedIn={isLoggedIn} />} />
                                    <Route path="/account/createproduct/" element={<CreateProduct userObj={userObj} isLoggedIn={isLoggedIn} />} />
                                </>
                            );
                        } else {
                            return (
                                <>
                                    <Route path="/account/" element={<Profile userObj={userObj} isLoggedIn={isLoggedIn} />} />
                                    <Route path="/account/confirm/:orderid" element={<Confirm userObj={userObj} isLoggedIn={isLoggedIn} />} />
                                </>
                            );
                        }
                    } else {
                        return (
                            <Route path="/account/" element={<SignIn />} />
                        )
                    }
                }()
            }
            </Routes>
        </Router>
    );
}

export default AppRouter;